import * as THREE from 'three'
import { types, getParent, IAnyModelType } from 'mobx-state-tree'
import {
  RectangularProperties,
  CircularProperties,
  EngravingProperties
} from 'src/api/models/Elements/Element/ElementProperties'
import { TextEngravingElement } from 'src/api/models/Elements/Element/TextEngravingElement'
import { generateElementType } from 'src/api/models/Elements/Element/generateElementType'
import {
  rectangularClippingElement,
  rectangularEngravingElement,
  circularClippingElement,
  circularEngravingElement
} from 'src/constants/typenames'
import {
  IElementUnion,
  ICircularClippingElement,
  ICircularEngravingElement,
  IRectangularClippingElement,
  IRectangularEngravingElement
} from './types'

// Clippings

const withColor = (type: IAnyModelType) =>
  type.views((self) => {
    // 5. CoverPlate 4. ElementConnection 3. types.array 2. ElementEdge 1.ClippingElement
    const coverPlate = getParent(self, 5) as any
    return {
      get color() {
        return coverPlate.properties.color
      }
    }
  })

export const RectangularClippingElement = generateElementType(
  rectangularClippingElement
).props({
  properties: types.optional(withColor(RectangularProperties), {})
}) as IRectangularClippingElement

export const CircularClippingElement = generateElementType(
  circularClippingElement
).props({
  properties: types.optional(withColor(CircularProperties), {})
}) as ICircularClippingElement

export const CircularEngravingElement = generateElementType(
  circularEngravingElement
).props({
  properties: types.optional(
    types.compose(EngravingProperties, CircularProperties),
    {}
  )
}) as ICircularEngravingElement

export const RectangularEngravingElement = generateElementType(
  rectangularEngravingElement
).props({
  properties: types.optional(
    types.compose(EngravingProperties, RectangularProperties),
    {}
  )
}) as IRectangularEngravingElement

export const Element: IElementUnion = types.union(
  RectangularClippingElement,
  CircularClippingElement,
  CircularEngravingElement,
  RectangularEngravingElement,
  TextEngravingElement
)
